import { AppConfigService } from './services/app-config.service';
import { AppConfig } from './models/app-config.model';
import { Observable } from 'rxjs';

export function initializeApplication(appConfigService: AppConfigService): () => Observable<AppConfig> {
  return (): Observable<AppConfig> => {
    return appConfigService.initialize();
  };
}
